import React from "react"
import Links from "../constants/links"
import { MdClose } from "react-icons/md"
const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <aside className={`sidebar ${isOpen ? "show-sidebar" : ""}`}>
      <button className="close-btn" onClick={toggleSidebar}>
        <MdClose></MdClose>
      </button>
      <div className="side-container">
        <Links styleClass={`${isOpen ? "sidebar-links" : ""}`}></Links>
      </div>
    </aside>
  )
}

export default Sidebar
